import React from 'react';
import MypageEventPresenter from './MypageEventPresenter';

const MypageEventContainer = (props) => {
  /* ===== ROUTE ===== */ /* ===== PROPS ===== */
  const { screenSize } = props;
  /* ===== Data ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <MypageEventPresenter screenSize={screenSize} />
    </>
  );
};

export default MypageEventContainer;
